import React, { ReactNode } from 'react';
import BottomNav from './BottomNav';
import styles from './Layout.module.scss';

interface LayoutProps {
    children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    return (
        <div className={styles.container}>
            <main className={styles.main}>
                {children}
            </main>
            <BottomNav />
        </div>
    );
};

export default Layout;